import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { resourceCards } from './mockData';
import ExternalLinkIcon from '../../assets/icons/external-link-icon.svg';
import { LazyBackgroundImage } from '../../components/LazyBackgroundImage/LazyBackgroundImage';
import { Loader } from '../../components/Loader/Loader';
import './ResourcePage.scss';

const ResourceCard = ({ titleKey, descriptionKey, imageUrl, link, t }: {
  titleKey: string;
  descriptionKey: string;
  imageUrl: string;
  link: string;
  t: (key: string) => string;
}) => (
  <div className="resource-card">
    <LazyBackgroundImage
      src={imageUrl}
      alt={t(titleKey)}
      className="resource-card__background"
    />
    <div className="resource-card__overlay">
      <div className="resource-card__content-wrapper">
        <h3>{t(titleKey)}</h3>
        <div className="resource-card__description">
          <span className="resource-card__description-preview">
            {t(descriptionKey).split('. ')[0]}...
          </span>
          <span className="resource-card__description-full">
            {t(descriptionKey)}
          </span>
        </div>
      </div>
      <button 
        className="resource-card__access-btn" 
        onClick={() => window.open(link, '_blank', 'noopener,noreferrer')}
      >
        {t('accessButton')} <img src={ExternalLinkIcon} alt="External link" className="external-link-icon" />
      </button>
    </div>
  </div>
);

const ResourcePage = () => {
  const { t } = useTranslation('resource');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate checking if initial resources are ready
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000); // Short delay to ensure smooth transition

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loader variant="fullscreen" />;
  }

  return (
    <div className="resource-page">
      <div className="resource-page__header">
        <h1>{t('title')}</h1>
        <p className="description">{t('description')}</p>
      </div>
      <div className="resource-page__grid">
        {resourceCards.map((card) => (
          <ResourceCard
            key={card.id}
            titleKey={card.titleKey}
            descriptionKey={card.descriptionKey}
            imageUrl={card.imageUrl}
            link={card.link}
            t={t}
          />
        ))}
      </div>
    </div>
  );
};

export default ResourcePage;
